import { StoryDocument } from '@backrs_ui/grow-ui/src/redux/profile/profile';
import { ENVIRONMENT_URL } from '@backrs_ui/grow-ui/src/settings';
import { fetchWrapper as fetch } from '@backrs_ui/grow-ui/src/utils/fetch/fetchWrapper';

type HandleDeleteStoryProps = Readonly<{
  selectedDocument: StoryDocument | null;
  onSuccess: (deletedId: number) => void;
  setOpenDialog: (open: boolean) => void;
  setError: (error: string | null) => void;
}>;

export const handleDeleteStory = async ({
  selectedDocument,
  onSuccess,
  setOpenDialog,
  setError,
}: HandleDeleteStoryProps) => {
  if (!selectedDocument) return;

  const id =
    selectedDocument?.category_id === 'video'
      ? selectedDocument.id
      : selectedDocument.profile_option_answers_id;

  const response = await fetch(`${ENVIRONMENT_URL}/users-profile-answers/${id}`, {
    method: 'DELETE',
  });

  if (response.ok) {
    onSuccess(selectedDocument.id);
    setError(null);
    setOpenDialog(false);
  } else {
    setError('We ran into an error deleting this story. Please try again.');
  }
};
